import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import StarIcon from "@mui/icons-material/Star";
import StreakCounter from "../../../components/StreakCounter";
import Paper from "@mui/material/Paper";

const SlidewordsHUD = ({
  wordsFound,
  bestWords,
  goalWords,
  currentDate,
  streak,
  isStreakActive,
  isMuted,
  onHelp,
  onMute,
  onDateClick,
  onStreakClick,
  totalWords = 5,
}) => (
  <Box
    sx={{ display: "flex", flexDirection: "column", gap: 1.5, width: "100%" }}
  >
    {/* Top row: Controls, Date, Streak */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {/* Left: Help */}
      <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="How to Play">
          <IconButton onClick={onHelp} sx={{ color: "#222" }}>
            <HelpOutlineIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={isMuted ? "Unmute" : "Mute"}>
          <IconButton onClick={onMute} sx={{ color: "#222" }}>
            {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
          </IconButton>
        </Tooltip>
      </Box>
      {/* Center: Date */}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: { xs: "1rem", sm: "1.1rem" },
          color: "#222",
          cursor: onDateClick ? "pointer" : "default",
          textDecoration: onDateClick ? "underline" : "none",
          transition: "text-decoration 0.2s",
          textAlign: "center",
          flex: 1,
        }}
        onClick={onDateClick}
      >
        {currentDate &&
          currentDate.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          })}
      </Typography>
      {/* Right: Streak */}
      <Tooltip title="Play daily to keep your streak!">
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <StreakCounter
            streak={streak}
            isActive={isStreakActive}
            onClick={onStreakClick}
          />
        </Box>
      </Tooltip>
    </Box>

    {/* Condensed stats row: Words Found, Goal, Best */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        gap: 0.5,
        flexWrap: "wrap",
      }}
    >
      {/* Words Found */}
      <Chip
        icon={<StarIcon sx={{ color: "#FFD700", fontSize: "1rem" }} />}
        label={`Words: ${wordsFound} / ${totalWords}`}
        sx={{
          bgcolor: "rgba(0, 0, 0, 0.08)",
          fontWeight: 600,
          color: "#000000",
          minWidth: { xs: 60, sm: 70 },
          fontSize: { xs: "0.85rem", sm: "0.95rem" },
          height: { xs: "28px", sm: "32px" },
        }}
      />
      {/* Goal */}
      <Chip
        label={`Goal: ${goalWords}`}
        sx={{
          bgcolor: "rgba(0, 0, 0, 0.08)",
          fontWeight: 600,
          color: "#000000",
          minWidth: { xs: 50, sm: 60 },
          fontSize: { xs: "0.85rem", sm: "0.95rem" },
          height: { xs: "28px", sm: "32px" },
        }}
      />
      {/* Best Words */}
      <Chip
        icon={<EmojiEventsIcon sx={{ color: "#FFD700", fontSize: "1rem" }} />}
        label={`Best: ${bestWords !== null ? bestWords : "---"}`}
        sx={{
          bgcolor: "rgba(0, 0, 0, 0.08)",
          fontWeight: 600,
          color: "#222",
          minWidth: { xs: 60, sm: 70 },
          fontSize: { xs: "0.85rem", sm: "0.95rem" },
          height: { xs: "28px", sm: "32px" },
        }}
      />
    </Box>
  </Box>
);

export default SlidewordsHUD;
